import React from "react";
import { Form, VisuallyHidden } from "react-aria-components";
import { t } from "ttag";

import { templates } from "@reactivated";

import { Clickable } from "../components/Clickables";
import { PageSkeleton } from "../components/PageSkeleton";
import { FormFields } from "../components/SoftPageGate";
import { Svg } from "../components/Svg";

import styles from "../components/SoftPageGate/dialog.module.scss";

export const Template = (props: templates.GatingFormPreview) => (
    <PageSkeleton
        {...(undefined as unknown as React.ComponentProps<typeof PageSkeleton>)}
        title={props.object.title}
        isPreview
    >
        <div>
            <Clickable onClick={() => undefined} className={styles.close}>
                <VisuallyHidden>{t`Close`}</VisuallyHidden>
                <Svg aria-hidden name="close" />
            </Clickable>
            <Form>
                <fieldset>
                    <FormFields value={props.object.fields.value} />
                </fieldset>
            </Form>
        </div>
    </PageSkeleton>
);
